import { forwardRef } from 'react';
import { Divider as AntdDivider } from 'antd';
import clsx from 'clsx';
import styles from './Divider.module.css';

/** @param {Object} props - Same shape as antd's own `Divider`, forwarded as-is. */
const Divider = forwardRef(({ className, ...props }, ref) => (
    <AntdDivider ref={ref} className={clsx(styles.vecDivider, className)} {...props} />
));
Divider.displayName = 'Divider';

export default Divider;
